import React from 'react';
import { TestimonialCard } from './TestimonialCard';

const testimonials = [
  {
    name: 'Priya Sharma',
    location: 'Mumbai',
    text: 'The Kundali analysis was spot-on! Nitika predicted my marriage timeline exactly and gave me the confidence to make important life decisions. Highly accurate!',
    rating: 5
  },
  {
    name: 'Rahul Verma',
    location: 'Delhi',
    text: 'I was confused about my career path. The Kundali report gave me clear direction and remedies. Within 2 months, I got my dream job! Thank you Nitika!',
    rating: 5
  },
  {
    name: 'Anjali Desai',
    location: 'Bangalore',
    text: 'The financial guidance from my Kundali reading helped me make smart investment decisions. Everything Nitika said about my money house came true!',
    rating: 5
  }
];

export const SocialProof = () => {
  return (
    <section className="py-20 sm:py-28 relative">
      {/* Background Texture */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/174d3dc0-fc62-4218-9cf1-1e8c201ee567/images/6cc817f4bfb2bcef42eb40d0288fe34c4380b0d2b1a6a520df64d1180dde5d37.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        {/* Section Label */}
        <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] text-center mb-4 font-light">
          TRUSTED GUIDANCE
        </p>

        <h2 className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug font-medium text-center text-white mb-3">
          Trusted by 1000+ people across India
        </h2>

        <p className="text-center text-[#A89B8C] mb-12 text-sm">
          Real stories from satisfied clients
        </p>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.name} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};
